"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlatGeoSuggest = void 0;
var _ramda = require("ramda");
var _getMultiSuggest = require("../../utils/getMultiSuggest");
var _requestActions = require("./requestActions");
var _geosuggestErrorMessages = require("../../constants/geosuggestErrorMessages");
/* eslint-disable  @typescript-eslint/no-explicit-any */

const processResponse = res => {
  const suggestLength = (0, _ramda.path)(['suggestions', 'addresses', 'length'], res);
  if (suggestLength) {
    return (0, _requestActions.successAction)(res);
  }
  return (0, _requestActions.failureAction)(_geosuggestErrorMessages.FLATS_NOT_FOUND_ERROR);
};

/**
 * Экшн загружает данные саджеста адресов из яндексовской апихи
 * */
const getFlatGeoSuggest = (addressChunk, targetPage) => async (dispatch, getState, context) => {
  const {
    config,
    logger
  } = context;
  dispatch((0, _requestActions.requestAction)());
  const apiKey = config.get('valuation.YandexApiKey');
  const suggestApiKey = config.get('valuation.YandexSuggestApiKey');
  if (apiKey && suggestApiKey) {
    try {
      const suggestResult = await (0, _getMultiSuggest.getMultiSuggest)({
        yandex: {
          value: addressChunk.trim(),
          apiKey,
          suggestApiKey
        },
        targetPage
      });
      const action = processResponse(suggestResult);
      dispatch(action);
    } catch (e) {
      dispatch((0, _requestActions.failureAction)(_geosuggestErrorMessages.SERVER_ERROR));
    }
  } else {
    logger.error('Failed get valuation.YandexApiKey or valuation.YandexSuggestApiKey. Suggest not working.', {
      domain: 'frontend-valuation-main-filters-widget__getFlatGeoSuggest'
    });
    dispatch((0, _requestActions.failureAction)(_geosuggestErrorMessages.SERVER_ERROR));
  }
};
exports.getFlatGeoSuggest = getFlatGeoSuggest;